import { useEffect, useState } from 'react';
import type { GeoPoint } from '@/utils/geo';

const GEO_OPTIONS: PositionOptions = {
  enableHighAccuracy: true,
  maximumAge: 5000,
  timeout: 15000,
};

/** Single watchPosition stream — avoids competing getCurrentPosition calls. */
export function useGeolocationWatch(enabled = true) {
  const [position, setPosition] = useState<GeoPoint | null>(null);
  const [available, setAvailable] = useState(true);

  useEffect(() => {
    if (!enabled || !('geolocation' in navigator)) {
      if (!('geolocation' in navigator)) setAvailable(false);
      return;
    }

    const watchId = navigator.geolocation.watchPosition(
      ({ coords }) => {
        setAvailable(true);
        setPosition({ lat: coords.latitude, lng: coords.longitude });
      },
      () => setAvailable(false),
      GEO_OPTIONS
    );

    return () => navigator.geolocation.clearWatch(watchId);
  }, [enabled]);

  return { position, available };
}

export { GEO_OPTIONS };
